import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Outcome from './Outcome';

function GradeLevel({ grade, user, classes, evidence, discipline = 'stem', onEvidenceChange, readOnly }) {
  const [objectiveIdMap, setObjectiveIdMap] = useState({});

  // Log the grade structure to debug data flow
  useEffect(() => {
    if (grade && grade.outcomes && grade.outcomes.length > 0) {
      const firstObj = grade.outcomes[0].objectives?.[0];
      const jsonStr = firstObj ? JSON.stringify(firstObj) : 'none';
      console.log(`[GradeLevel] Grade "${grade.name || grade.id}" (source: ${grade._source || 'UNKNOWN'}):`, {
        outcomes_count: grade.outcomes.length,
        first_objective_type: typeof firstObj,
        first_objective_sample: (jsonStr && jsonStr !== 'undefined') ? jsonStr.substring(0, 80) : 'none'
      });
    }
  }, [grade?.id, grade?._source]);

  // Build a map of numeric objective IDs to outcome structure
  useEffect(() => {
    const buildMap = async () => {
      try {
        const response = await axios.get('/outcomes/api/objectives-hierarchy', { 
          params: { discipline },
          timeout: 5000, 
          withCredentials: true 
        });
        const map = {};
        
        if (!Array.isArray(response.data)) {
          console.error('[GradeLevel] API response is not an array:', response.data);
          return;
        }
        
        for (const gb of response.data) {
          if (!Array.isArray(gb.outcomes)) {
            console.error('[GradeLevel] Gradeband outcomes is not an array for:', gb.id);
            continue;
          }
          
          for (const outcome of gb.outcomes) {
            if (!Array.isArray(outcome.objectives)) {
              console.error('[GradeLevel] Outcome objectives is not an array for:', outcome.id);
              continue;
            }
            
            for (const obj of outcome.objectives) {
              // Map: numeric ID -> { gradeband: gb.name, outcome_number: outcome.number, obj_index: obj.number }
              map[obj.id] = {
                gradeband: gb.name,
                outcome_number: outcome.number,
                obj_index: obj.number
              };
            }
          }
        }
        
        setObjectiveIdMap(map);
      } catch (error) {
        console.error('[GradeLevel] Failed to load objective mappings:', error.message);
      }
    };

    buildMap();
  }, [discipline]);

  const getOutcomeIdForObjective = (numericId) => {
    const mapping = objectiveIdMap[numericId];
    if (mapping && mapping.gradeband === grade.id) {
      return `${grade.id}-${mapping.outcome_number}`;
    }
    return null;
  };

  return (
    <div>
      {!grade ? (
        <div className="empty-state">
          <p>No grade levels available. Create a gradeband first in the Objectives section.</p>
        </div>
      ) : (
        <>
          <div className="grade-header">
            <h2>{grade.title}</h2>
            <p>{grade.description}</p>
          </div>

          <div className="outcomes-list">
            {grade.outcomes.map((outcome) => {
              // Pass all evidence to Outcome - it will filter by objective ID
              return (
                <Outcome
                  key={outcome.id}
                  outcomeId={outcome.id}
                  outcome={outcome}
                  gradeId={grade.id}
                  user={user}
                  classes={classes}
                  evidence={evidence}
                  discipline={discipline}
                  onEvidenceChange={onEvidenceChange}
                  readOnly={readOnly}
                  objectiveIdMap={objectiveIdMap}
                />
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default GradeLevel;